import React from 'react'
import { isSite } from '~/tools/isSite';

class FeaturedEpisodeInfo extends React.Component {
	render() {
		let { 
			title, 
			description, 
			videoImageUrl, 
			seasonTitle, 
			episodeNumber, 
			seasonNumber
		} = this.props.episodeDetails.gist
		const showData = this.props.showData
		const seasonPass = this.props.seasonPass
		const isSeriesPurchaseable = !showData.gist.free &&
		(showData.pricing && showData.pricing.purchase !== null) &&
		this.props.seriesPurchaseStatus;
		return(
			<div className="next-episode-info">
				<div className="episode-info-wrapper">
					<div className="next-episode-img" onClick={(e) => {
						this.props.openEpisodeOverlay(e, !seasonPass ? episodeNumber - 1 : episodeNumber, seasonNumber, this.props.episodeDetails)
					}}>
						<div className="image" style={{ backgroundImage: `url(${videoImageUrl})` }}>
							<div className="play-icon site-color">
								<i className="ion-ios-play"></i>
							</div>
						</div>
						<button className="button cta"> Watch Now </button>
					</div>
					<div className="details">
						<div className="episode-name">
							<span className="season-episode-details">{`${seasonTitle} : ${isSite('bingeflix') ? 'P' : 'E'}${episodeNumber}`}</span>
							<span className="name">{title}</span>
						</div>
						<div className="next-episode-desc">{description}</div>
					</div>
				</div>
				{isSeriesPurchaseable && (	
					<div className="purchase-series-cta cta" onClick={(e) => {
						this.props.openEpisodeOverlay(e, 0, 0, showData)
					}}>Purchase All</div>
				)}
			</div>
		)
	}
}
export default FeaturedEpisodeInfo;
